import React from "react";

import * as Ant from "antd";

import "antd/dist/antd.css";

import styles from "./form.local.scss";

export const { Option } = Ant.Select;

export function Input(props) {
  let { light, afterInput } = props;

  let ps = { ...props };
  delete ps.afterInput;
  delete ps.light;

  return light ? (
    <div className={styles.input__light} style={props.style}>
      <input {...ps} />
      <span>{afterInput}</span>
    </div>
  ) : (
    <Ant.Input {...ps} />
  );
}

export function Button(props) {
  return (
    <Ant.Button
      {...props}
      className={
        styles["button__" + (props.type || "default")] + " " + props.className
      }
    >
      {props.children}
    </Ant.Button>
  );
}

export function Select(props) {
  return (
    <Ant.Select {...props} className={styles.select + " " + props.className}>
      {props.children}
    </Ant.Select>
  );
}



// WEBPACK FOOTER //
// ./src/components/UI/form.js